import * as Types from '../../../../../../../__generated__/schema';

import { AlertActivityHistoryFull } from '../../../../../../graphql/fragments/AlertActivityHistory.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AlertActivityHistoryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  activityHistoryPageInfo?: Types.InputMaybe<Types.AlertActivityHistoryInput>;
}>;

export type AlertActivityHistory = {
  alert: Pick<Types.Alert, 'id'> & { activityHistory?: Types.Maybe<AlertActivityHistoryFull> };
};

export const AlertActivityHistoryDocument = gql`
  query AlertActivityHistory($id: ID!, $activityHistoryPageInfo: AlertActivityHistoryInput) {
    alert(id: $id) {
      id
      activityHistory(input: $activityHistoryPageInfo) {
        ...AlertActivityHistoryFull
      }
    }
  }
  ${AlertActivityHistoryFull}
`;

/**
 * __useAlertActivityHistory__
 *
 * To run a query within a React component, call `useAlertActivityHistory` and pass it any options that fit your needs.
 * When your component renders, `useAlertActivityHistory` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertActivityHistory({
 *   variables: {
 *      id: // value for 'id'
 *      activityHistoryPageInfo: // value for 'activityHistoryPageInfo'
 *   },
 * });
 */
export function useAlertActivityHistory(
  baseOptions: Apollo.QueryHookOptions<AlertActivityHistory, AlertActivityHistoryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AlertActivityHistory, AlertActivityHistoryVariables>(
    AlertActivityHistoryDocument,
    options,
  );
}
export function useAlertActivityHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AlertActivityHistory, AlertActivityHistoryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AlertActivityHistory, AlertActivityHistoryVariables>(
    AlertActivityHistoryDocument,
    options,
  );
}
export function useAlertActivityHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AlertActivityHistory,
    AlertActivityHistoryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AlertActivityHistory, AlertActivityHistoryVariables>(
    AlertActivityHistoryDocument,
    options,
  );
}
export type AlertActivityHistoryHookResult = ReturnType<typeof useAlertActivityHistory>;
export type AlertActivityHistoryLazyQueryHookResult = ReturnType<
  typeof useAlertActivityHistoryLazyQuery
>;
export type AlertActivityHistorySuspenseQueryHookResult = ReturnType<
  typeof useAlertActivityHistorySuspenseQuery
>;
export type AlertActivityHistoryQueryResult = Apollo.QueryResult<
  AlertActivityHistory,
  AlertActivityHistoryVariables
>;
export function mockAlertActivityHistory({
  data,
  variables,
  errors,
}: {
  data: AlertActivityHistory;
  variables?: AlertActivityHistoryVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: AlertActivityHistoryDocument, variables },
    result: { data, errors },
  };
}
